(function () {
  if (window.cartSavingsHubBound) return;
  window.cartSavingsHubBound = true;

  const LOYALTY_CACHE = 'kalki_store_credit_cache';
  const LOYALTY_URL = 'https://api.kalkifashion.com/kalki-credit/store-credit-proxy.php';
  const APPLY_KEY = 'kalki_discount_try';
  const STOREFRONT_TOKEN = (typeof window !== 'undefined' && window.storefrontAccessToken) || 'adce4ee916b13aa6db2d71a2662a8f91';
  const STOREFRONT_API_URL = '/api/2024-10/graphql.json';

  function hubs() {
    return document.querySelectorAll('[data-cart-savings-hub]');
  }

  function resolveCartId() {
    if (window.customerCartId) return Promise.resolve(window.customerCartId);
    const cookieMatch = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    if (cookieMatch) {
      try {
        const raw = decodeURIComponent(cookieMatch[1].trim());
        if (raw) return Promise.resolve('gid://shopify/Cart/' + raw);
      } catch (e) {}
    }
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return cart && cart.token ? 'gid://shopify/Cart/' + cart.token : null;
      })
      .catch(function () { return null; });
  }

  function updateCartUI() {
    const drawerItems = document.querySelector('cart-drawer-items');
    const pageCartItems = document.querySelector('cart-items');
    let updated = false;
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
      drawerItems.onCartUpdate();
      updated = true;
    }
    if (pageCartItems && typeof pageCartItems.onCartUpdate === 'function') {
      pageCartItems.onCartUpdate();
      updated = true;
    }
    if (!updated) {
      if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'coupon' });
      } else {
        window.location.reload();
      }
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function showStatus(button, message) {
    const root = button && button.closest('[data-cart-savings-hub]');
    const status = root && root.querySelector('[data-rewards-status]');
    if (status) status.textContent = message;

    const errorEl = (root && root.querySelector('[data-coupon-error]')) || document.querySelector('[data-coupon-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = message ? 'block' : 'none';
    }

    if (button) {
      button.disabled = false;
      if (button.hasAttribute('data-apply-coupon') && button.textContent.indexOf('Applying') !== -1) {
        button.textContent = button.getAttribute('data-apply-coupon') === 'FREE' ? 'Apply FREE' : 'Apply';
      } else if (button.getAttribute('type') === 'submit' || button.tagName === 'BUTTON') {
        button.textContent = 'Apply';
      }
    }
  }

  function formatSavingsMoney(amount, currency) {
    const val = Number(amount || 0);
    let dollars = val;
    if (val > 100 && Math.floor(val) === val) {
      dollars = val / 100;
    }
    const symbol = currency === 'GBP' ? '£' : currency === 'EUR' ? '€' : currency === 'INR' ? '₹' : '$';
    if (dollars % 1 === 0) {
      return symbol + dollars.toFixed(0);
    }
    return symbol + dollars.toFixed(2);
  }

  function calculateCouponSavings(code, cart, button) {
    const cleanCode = (code || '').trim().toLowerCase();
    let savingsCents = 0;
    let currency = (cart && cart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const symbol = currency === 'GBP' ? '£' : currency === 'EUR' ? '€' : currency === 'INR' ? '₹' : '$';

    // 1. First priority: Check if this coupon card is in the DOM with a dynamic calculated "You save $X" amount
    let card = button ? (button.closest('.cart-coupon-card') || button.closest('[data-coupon-code]')) : null;
    if (!card && cleanCode) {
      card = document.querySelector(`[data-coupon-code="${code}" i], [data-coupon-code="${cleanCode}"]`);
    }
    if (card) {
      const saveTextEl = card.querySelector('.cart-savings-hub__offer-save');
      if (saveTextEl && saveTextEl.textContent) {
        const match = saveTextEl.textContent.match(/([$£€₹])\s*([0-9,.]+)/);
        if (match) {
          const num = parseFloat(match[2].replace(/,/g, ''));
          if (num > 0) {
            return match[1] + (num % 1 === 0 ? num.toFixed(0) : num.toFixed(2));
          }
        }
      }
    }

    // 2. Check Shopify cart discount allocations specifically for this coupon code
    if (cart) {
      if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length > 0) {
        const app = cart.cart_level_discount_applications.find(function (a) {
          return a && a.title && a.title.toLowerCase() === cleanCode;
        });
        if (app && app.total_allocated_amount > 0) {
          savingsCents = app.total_allocated_amount;
        }
      }

      if (savingsCents <= 0 && Array.isArray(cart.items)) {
        let lineAllocSum = 0;
        cart.items.forEach(function (item) {
          if (Array.isArray(item.line_level_discount_allocations)) {
            item.line_level_discount_allocations.forEach(function (alloc) {
              if (alloc && alloc.discount_application && alloc.discount_application.title && alloc.discount_application.title.toLowerCase() === cleanCode) {
                lineAllocSum += Number(alloc.amount || 0);
              }
            });
          }
        });
        if (lineAllocSum > 0) {
          savingsCents = lineAllocSum;
        }
      }

      if (savingsCents <= 0 && cart.total_discount > 0) {
        savingsCents = cart.total_discount;
      }
    }

    if (savingsCents > 0) {
      return formatSavingsMoney(savingsCents, currency);
    }

    // 3. Fallback: Extract numeric amount from code name (e.g. TEST55 -> $55)
    if (code) {
      const numMatch = code.match(/\d+/);
      if (numMatch) {
        const num = parseFloat(numMatch[0]);
        if (num > 0) {
          return symbol + (num % 1 === 0 ? num.toFixed(0) : num.toFixed(2));
        }
      }
    }

    return symbol + '0';
  }

  let couponModalTimer = null;

  function showCouponSuccessModal(code, savingsText) {
    if (couponModalTimer) {
      clearTimeout(couponModalTimer);
      couponModalTimer = null;
    }

    let overlay = document.querySelector('[data-coupon-success-modal]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'coupon-success-modal-overlay';
      overlay.setAttribute('data-coupon-success-modal', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = `
        <div class="coupon-success-modal" role="dialog" aria-modal="true" aria-labelledby="CouponModalHeading">
          <div class="coupon-success-modal__confetti" aria-hidden="true">
            <svg class="coupon-success-modal__confetti-svg" viewBox="0 0 360 130" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.95">
                <path d="M22 28 C30 18, 42 34, 52 24 C58 18, 64 30, 72 20" stroke="#D4AF37" stroke-width="2.5" stroke-linecap="round" fill="none"/>
                <path d="M130 15 C138 25, 148 10, 156 22 C162 30, 172 16, 180 26" stroke="#F3C64F" stroke-width="2.2" stroke-linecap="round" fill="none"/>
                <path d="M220 22 C230 12, 240 28, 252 16 C258 24, 268 14, 276 22" stroke="#E5A93C" stroke-width="2.5" stroke-linecap="round" fill="none"/>
                <path d="M305 32 C312 20, 324 35, 336 22" stroke="#FFD700" stroke-width="2.2" stroke-linecap="round" fill="none"/>
                <path d="M45 42l4-2-2 5-3-3z" fill="#E5A93C" transform="rotate(18 45 42)"/>
                <path d="M95 18l5 2-3 4-4-3z" fill="#FFD700" transform="rotate(-15 95 18)"/>
                <path d="M195 38l4 3-5 1 2-5z" fill="#F3C64F" transform="rotate(40 195 38)"/>
                <path d="M285 45l3 4-4 2-1-5z" fill="#E5A93C" transform="rotate(-30 285 45)"/>
                <circle cx="35" cy="18" r="2.5" fill="#FFD700"/>
                <circle cx="85" cy="38" r="3" fill="#E5A93C"/>
                <circle cx="115" cy="25" r="2" fill="#F3C64F"/>
                <circle cx="170" cy="12" r="3.5" fill="#FFD700"/>
                <circle cx="210" cy="35" r="2.5" fill="#E5A93C"/>
                <circle cx="265" cy="16" r="3" fill="#F3C64F"/>
                <circle cx="320" cy="42" r="2.5" fill="#FFD700"/>
                <rect x="60" y="28" width="6" height="4" fill="#F3C64F" rx="1" transform="rotate(25 60 28)"/>
                <rect x="145" y="32" width="5" height="5" fill="#D4AF37" rx="1" transform="rotate(-20 145 32)"/>
                <rect x="235" y="26" width="6" height="4" fill="#E5A93C" rx="1" transform="rotate(35 235 26)"/>
                <rect x="300" y="18" width="4" height="6" fill="#FFD700" rx="1" transform="rotate(-10 300 18)"/>
              </g>
            </svg>
          </div>
          <div class="coupon-success-modal__icon">
            <img src="${window.couponSuccessIconUrl || ''}" onerror="this.style.display='none';if(this.nextElementSibling)this.nextElementSibling.style.display='block';" alt="Coupon Applied" width="80" height="54">
            <svg style="${window.couponSuccessIconUrl ? 'display:none;' : ''}" width="80" height="54" viewBox="0 0 100 68" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M90 0H10C4.477 0 0 4.477 0 10v16c4.418 0 8 3.582 8 8s-3.582 8-8 8v16c0 5.523 4.477 10 10 10h80c5.523 0 10-4.477 10-10V42c-4.418 0-8-3.582-8-8s3.582-8 8-8V10c0-5.523-4.477-10-10-10z" fill="#44A546"/>
              <path d="M30 14v40" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-dasharray="2 6"/>
              <text x="63" y="44" fill="#fff" font-size="28" font-weight="900" font-family="Arial, sans-serif" text-anchor="middle">%</text>
            </svg>
          </div>
          <h3 id="CouponModalHeading" class="coupon-success-modal__title">
            <strong data-coupon-modal-code>${code}</strong> Applied !
          </h3>
          <p class="coupon-success-modal__save-msg">
            You save <span data-coupon-modal-save-short>${savingsText}</span>
          </p>
          <div class="coupon-success-modal__body">
            <p class="coupon-success-modal__label">Total Savings</p>
            <div class="coupon-success-modal__total-amount" data-coupon-modal-save-big>${savingsText}</div>
          </div>
          <button type="button" class="coupon-success-modal__btn" data-close-coupon-modal>AWESOME</button>
        </div>
      `;
      document.body.appendChild(overlay);
    } else if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    const codeEl = overlay.querySelector('[data-coupon-modal-code]');
    const shortSaveEl = overlay.querySelector('[data-coupon-modal-save-short]');
    const bigSaveEl = overlay.querySelector('[data-coupon-modal-save-big]');

    if (codeEl) codeEl.textContent = code;
    if (shortSaveEl) shortSaveEl.textContent = savingsText;
    if (bigSaveEl) bigSaveEl.textContent = savingsText;

    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');

    // Keep open for 5 seconds unless user clicks AWESOME button earlier
    couponModalTimer = setTimeout(function () {
      hideCouponSuccessModal();
    }, 5000);
  }

  function hideCouponSuccessModal() {
    if (couponModalTimer) {
      clearTimeout(couponModalTimer);
      couponModalTimer = null;
    }
    const overlay = document.querySelector('[data-coupon-success-modal]');
    if (overlay) {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
    try {
      sessionStorage.removeItem('kalki_applied_coupon_modal');
    } catch (e) {}
  }

  function checkStoredCouponModal() {
    try {
      const stored = sessionStorage.getItem('kalki_applied_coupon_modal');
      if (stored) {
        sessionStorage.removeItem('kalki_applied_coupon_modal');
        const data = JSON.parse(stored);
        if (data && data.code) {
          setTimeout(function () {
            showCouponSuccessModal(data.code, data.savings || '$5');
          }, 400);
        }
      }
    } catch (e) {}
  }

  function applyGiftCard(rawCode, button) {
    const code = (rawCode || '').trim().replace(/[\s-]+/g, '');
    if (!code) return Promise.resolve(false);

    const token = (typeof window !== 'undefined' && window.storefrontAccessToken) || STOREFRONT_TOKEN;

    function handleAppliedCards(appliedGiftCards) {
      if (appliedGiftCards && appliedGiftCards.length > 0) {
        const totalBalance = appliedGiftCards.reduce(function (sum, g) {
          const val = parseFloat((g.balance && g.balance.amount) || (g.amountUsed && g.amountUsed.amount) || 0);
          return sum + val;
        }, 0);
        const currency = (appliedGiftCards[0].balance && appliedGiftCards[0].balance.currencyCode) || (appliedGiftCards[0].amountUsed && appliedGiftCards[0].amountUsed.currencyCode) || 'GBP';
        const last4 = appliedGiftCards.map(function (g) { return g.lastCharacters; }).join(', ');
        const savingsFormatted = formatSavingsMoney(totalBalance, currency);

        return fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (currCart) {
            const updatePayload = {
              attributes: {
                _gift_card_applied: 'true',
                _gift_card_code: code,
                _gift_card_amount: String(totalBalance),
                _gift_card_last_four: last4,
                _gift_card_currency: currency
              }
            };
            const codes = (currCart && currCart.discount_codes) || [];
            const hasInvalidDiscount = codes.some(function (c) { return c && c.applicable === false; });
            if (hasInvalidDiscount) {
              updatePayload.discount = '';
            }
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(updatePayload)
            });
          })
          .then(function () {
            try {
              sessionStorage.setItem('kalki_applied_coupon_modal', JSON.stringify({
                code: 'Gift Card (•••• ' + last4 + ')',
                savings: savingsFormatted
              }));
            } catch (e) {}
            showCouponSuccessModal('Gift Card (•••• ' + last4 + ')', savingsFormatted);
            updateCartUI();
            setCouponPanel(false);
            return true;
          });
      }
      return Promise.resolve(false);
    }

    return fetch(STOREFRONT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({
        query: `mutation cartCreateWithGiftCard($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              appliedGiftCards {
                amountUsed { amount currencyCode }
                balance { amount currencyCode }
                lastCharacters
              }
            }
            userErrors { field message code }
          }
        }`,
        variables: {
          input: {
            giftCardCodes: [code]
          }
        }
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        const cartData = data && data.data && data.data.cartCreate && data.data.cartCreate.cart;
        const appliedGiftCards = (cartData && cartData.appliedGiftCards) || [];
        if (appliedGiftCards.length > 0) {
          resolveCartId().then(function (cartId) {
            if (cartId) {
              fetch(STOREFRONT_API_URL, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': token,
                },
                body: JSON.stringify({
                  query: `mutation cartGiftCardCodesUpdate($cartId: ID!, $giftCardCodes: [String!]!) {
                    cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $giftCardCodes) {
                      cart { id }
                    }
                  }`,
                  variables: { cartId: cartId, giftCardCodes: [code] }
                })
              }).catch(function () {});
            }
          }).catch(function () {});

          return handleAppliedCards(appliedGiftCards);
        }
        return false;
      })
      .catch(function () {
        return false;
      });
  }

  function removeGiftCard(button) {
    if (button) {
      button.disabled = true;
      button.textContent = button.textContent === '×' ? '×' : 'Removing…';
    }

    const token = (typeof window !== 'undefined' && window.storefrontAccessToken) || STOREFRONT_TOKEN;

    return resolveCartId().then(function (cartId) {
      const sfPromise = cartId ? fetch(STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({
          query: `mutation cartGiftCardCodesUpdate($cartId: ID!, $giftCardCodes: [String!]!) {
            cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $giftCardCodes) {
              cart { id appliedGiftCards { lastCharacters } }
              userErrors { field message }
            }
          }`,
          variables: { cartId: cartId, giftCardCodes: [] }
        })
      }).catch(function () { return null; }) : Promise.resolve(null);

      return sfPromise.then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              _gift_card_applied: '',
              _gift_card_code: '',
              _gift_card_amount: '',
              _gift_card_last_four: '',
              _gift_card_currency: ''
            }
          })
        });
      })
        .then(function () {
          updateCartUI();
        })
        .catch(function () {
          if (button) button.disabled = false;
        });
    });
  }

  function tryApplyDiscountCode(code, redirectPath, button, alreadyTriedGiftCard) {
    if (!code) return Promise.resolve();
    const redirect = redirectPath || window.location.pathname || '/cart';
    const tryKey = APPLY_KEY + '_' + code.toLowerCase();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart.status) {
          throw new Error(cart.description || cart.message || 'Could not apply coupon.');
        }
        const codes = cart.discount_codes || [];
        const applied = codes.some(function (entry) {
          return entry && entry.code && entry.code.toLowerCase() === code.toLowerCase() && entry.applicable !== false;
        });
        if (applied) {
          const savings = calculateCouponSavings(code, cart, button);
          try {
            sessionStorage.setItem('kalki_applied_coupon_modal', JSON.stringify({ code: code, savings: savings }));
          } catch (e) {}
          showCouponSuccessModal(code, savings);
          updateCartUI();
          setCouponPanel(false);
          return;
        }

        if (!alreadyTriedGiftCard) {
          return applyGiftCard(code, button).then(function (isGiftSuccess) {
            if (isGiftSuccess) return;
            return tryDiscountFallback(code, redirect, button, tryKey);
          }).catch(function () {
            return tryDiscountFallback(code, redirect, button, tryKey);
          });
        }

        return tryDiscountFallback(code, redirect, button, tryKey);
      })
      .catch(function (error) {
        if (!alreadyTriedGiftCard) {
          return applyGiftCard(code, button).then(function (isGiftSuccess) {
            if (isGiftSuccess) return;
            showStatus(button, error.message || 'Could not apply coupon or gift card.');
          }).catch(function () {
            showStatus(button, error.message || 'Could not apply coupon or gift card.');
          });
        }
        showStatus(button, error.message || 'Could not apply coupon or gift card.');
      });
  }

  function tryDiscountFallback(code, redirect, button, tryKey) {
    let alreadyTried = '';
    try {
      alreadyTried = sessionStorage.getItem(tryKey) || '';
    } catch (e) {}
    if (alreadyTried === '1') {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).catch(function () {});
      showStatus(button, 'Could not apply ' + code + '. This coupon is not valid for this user account.');
      return;
    }
    try {
      sessionStorage.setItem(tryKey, '1');
    } catch (e) {}

    // Fallback: Silent background fetch to set discount cookie
    return fetch('/discount/' + encodeURIComponent(code))
      .then(function () {
        return fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (newCart) {
            const newCodes = newCart.discount_codes || [];
            const isAppliedNow = newCodes.some(function (entry) {
              return entry && entry.code && entry.code.toLowerCase() === code.toLowerCase() && entry.applicable !== false;
            });
            if (isAppliedNow) {
              const savings = calculateCouponSavings(code, newCart, button);
              try {
                sessionStorage.setItem('kalki_applied_coupon_modal', JSON.stringify({ code: code, savings: savings }));
              } catch (e) {}
              showCouponSuccessModal(code, savings);
              updateCartUI();
              setCouponPanel(false);
            } else {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
              }).catch(function () {});
              showStatus(button, 'Could not apply ' + code + '. Check the code.');
            }
          });
      })
      .catch(function () {
        showStatus(button, 'Could not apply ' + code + '. Check the code.');
      });
  }

  function applyCoupon(code, redirectPath, button) {
    if (!code) return Promise.resolve();
    const cleanRaw = (code || '').trim();
    const cleanNoSpaces = cleanRaw.replace(/[\s-]+/g, '');
    const isLikelyGiftCard = /^[a-zA-Z0-9]{16}$/.test(cleanNoSpaces);

    if (button) {
      button.disabled = true;
      button.textContent = 'Applying…';
    }

    if (isLikelyGiftCard) {
      return applyGiftCard(cleanNoSpaces, button)
        .then(function (success) {
          if (success) return;
          return tryApplyDiscountCode(cleanRaw, redirectPath, button, true);
        })
        .catch(function () {
          return tryApplyDiscountCode(cleanRaw, redirectPath, button, true);
        });
    }

    return tryApplyDiscountCode(cleanRaw, redirectPath, button, false);
  }

  function formatMoney(amount, currency) {
    const value = Number(amount || 0);
    const symbol = currency === 'USD' ? '$' : currency === 'GBP' ? '£' : currency === 'EUR' ? '€' : '$';
    return symbol + value.toFixed(2);
  }

  function formatWholeMoney(major, currency) {
    const code = currency || 'USD';
    const locale = code === 'INR' ? 'en-IN' : 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(major);
    } catch (e) {
      const symbol = code === 'INR' ? '₹' : code === 'GBP' ? '£' : code === 'EUR' ? '€' : '$';
      return symbol + String(major);
    }
  }

  function moneyToCents(text) {
    const value = parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
    if (!isFinite(value)) return null;
    return Math.round(value * 100);
  }

  function estimatedCentsForEarn(root) {
    const scope = root.closest('cart-drawer') || root.closest('.cart-wrapper') || document;
    const totalEl = scope.querySelector('.cart-order-summary .grand-total-row .totals__total-value');
    const fromSummary = totalEl ? moneyToCents(totalEl.textContent) : null;
    if (fromSummary != null) return fromSummary;
    const preset = Number(root.getAttribute('data-cart-total-price'));
    return isFinite(preset) ? preset : 0;
  }

  function refreshEarnLines() {
    document.querySelectorAll('[data-kc-earn]').forEach(function (root) {
      const scope = root.closest('cart-drawer') || root.closest('.cart-wrapper') || document;
      const markedEmpty = !!(
        (root.closest('.cart-wrapper') && root.closest('.cart-wrapper').classList.contains('is-empty')) ||
        (root.closest('cart-drawer') && root.closest('cart-drawer').classList.contains('is-empty'))
      );
      const lineCount = scope.querySelectorAll('.cart-item, [js-cart-item-details]').length;
      if (markedEmpty || lineCount === 0) {
        root.hidden = true;
        return;
      }
      const totalEl = scope.querySelector('.cart-order-summary .grand-total-row .totals__total-value');
      const estimated = estimatedCentsForEarn(root);
      const major = Math.round(estimated / 1000);
      const sample = totalEl ? totalEl.textContent : '';
      const symbol = (String(sample).match(/^[^\d-]+/) || ['$'])[0];
      const label = major.toLocaleString('en-US') + ' Points';
      root.setAttribute('data-cart-total-price', String(estimated));
      const amount = root.querySelector('[data-kc-earn-amount]');
      if (amount) amount.textContent = label;
      root.hidden = major <= 0;
    });
  }

  function renderLoyalty(root, data) {
    const slot = root.querySelector('[data-loyalty-balance]');
    const copy = root.querySelector('[data-rewards-copy]');
    const applyBtn = root.querySelector('[data-apply-store-credit]');
    const credit = parseFloat(data.store_credit_balance || 0);
    const points = Number(data.points_balance || 0);
    const currency = data.store_credit_currency || 'USD';
    const parts = [];
    if (credit > 0) parts.push(formatMoney(credit, currency) + ' store credit');
    if (points > 0) parts.push(points + ' points');
    if (slot) slot.textContent = parts.length ? 'Loyalty · ' + parts.join(' · ') : 'Loyalty · none yet';
    if (copy) {
      copy.textContent = parts.length
        ? parts.join(' · ') + ' available on this account.'
        : 'No store credit yet.';
    }
    if (applyBtn) {
      applyBtn.hidden = !(credit > 0);
      applyBtn.textContent = credit > 0 ? 'Use ' + formatMoney(credit, currency) + ' credit' : 'Use store credit';
      applyBtn.setAttribute('data-credit-amount', String(credit));
      applyBtn.setAttribute('data-credit-currency', currency);
    }
    if (root.classList.contains('mini-loyalty')) {
      const cartTotalPriceCents = parseFloat(root.getAttribute('data-cart-total-price') || 0);
      const earnPoints = Math.round(cartTotalPriceCents / 100);
      if (slot && earnPoints >= 0) {
        if (root.getAttribute('data-logged-in') === 'true') {
          slot.innerHTML =
            'You will earn ' +
            earnPoints +
            ' Loyalty point' +
            (earnPoints === 1 ? '' : 's') +
            ' on this order (50 Point = $1)';
        } else {
          slot.innerHTML =
            '<a href="/account/login">Log in</a> to earn loyalty points on this order (50 Point = $1)';
        }
      }
      return;
    }
  }

  function loadLoyalty() {
    hubs().forEach(function (root) {
      if (root.getAttribute('data-logged-in') !== 'true') return;
      const email = root.getAttribute('data-customer-email');
      if (!email) return;

      try {
        const cached = localStorage.getItem(LOYALTY_CACHE);
        if (cached) {
          const parsed = JSON.parse(cached);
          if (parsed && parsed.data && Date.now() - parsed.timestamp < 5 * 60 * 1000) {
            renderLoyalty(root, parsed.data);
            return;
          }
        }
      } catch (e) {}

      fetch(LOYALTY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email }),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (result) {
          const data = (result.body && result.body.data) || result.body || {};
          if (data.store_credit_balance != null || data.points_balance != null) {
            try {
              localStorage.setItem(LOYALTY_CACHE, JSON.stringify({ data: data, timestamp: Date.now() }));
            } catch (e) {}
            renderLoyalty(root, data);
            return;
          }
          renderLoyalty(root, { store_credit_balance: 0, points_balance: 0 });
        })
        .catch(function () {
          const slot = root.querySelector('[data-loyalty-balance]');
          if (slot) slot.textContent = 'Loyalty · unavailable';
        });
    });
  }

  function applyStoreCredit(button) {
    const root = button.closest('[data-cart-savings-hub]');
    const amount = button.getAttribute('data-credit-amount') || '0';
    const email = root && root.getAttribute('data-customer-email');
    button.disabled = true;
    button.textContent = 'Applying…';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          store_credit_apply: 'true',
          store_credit_amount: amount,
        },
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return fetch(LOYALTY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            action: 'apply',
            amount: amount,
          }),
        }).catch(function () {
          return null;
        });
      })
      .then(function (res) {
        if (!res || !res.json) return null;
        return res.json().catch(function () {
          return null;
        });
      })
      .then(function (result) {
        const data = result && (result.data || result);
        const code = data && (data.discount_code || data.code);
        if (code) {
          return applyCoupon(code, window.location.pathname, button);
        }
        showStatus(button, 'Credit flagged on this cart. It will come off at checkout when you pay while logged in.');
        button.textContent = 'Credit ready at checkout';
      })
      .catch(function () {
        showStatus(button, 'Could not apply store credit. It may still appear at checkout.');
      });
  }

  function removeCoupon(button) {
    if (button) {
      button.disabled = true;
      button.textContent = button.textContent === '×' ? '×' : 'Removing…';
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ discount: '' }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        updateCartUI();
      })
      .catch(function () {
        if (button) button.disabled = false;
      });
  }

  function couponPanel() {
    return document.querySelector('[data-coupon-panel]');
  }

  function setCouponPanel(open) {
    const panel = couponPanel();
    const drawer = document.querySelector('.cart-drawer .drawer__inner');
    if (!panel) return;
    panel.hidden = !open;
    if (drawer) drawer.classList.toggle('is-coupons-open', open);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-close-coupon-modal]')) {
      event.preventDefault();
      hideCouponSuccessModal();
      return;
    }
    const overlay = event.target.closest('[data-coupon-success-modal]');
    if (overlay && event.target === overlay) {
      hideCouponSuccessModal();
      return;
    }

    const rewardsToggle = event.target.closest('[data-open-rewards]');
    if (rewardsToggle) {
      event.preventDefault();
      const root = rewardsToggle.closest('[data-cart-savings-hub]');
      const panel = root && root.querySelector('[data-rewards-panel]');
      if (panel) panel.hidden = !panel.hidden;
      return;
    }

    const openCoupons = event.target.closest('[data-open-coupons]');
    if (openCoupons) {
      event.preventDefault();
      setCouponPanel(true);
      return;
    }

    const openCouponsPage = event.target.closest('[data-open-coupons-page]');
    if (openCouponsPage) {
      event.preventDefault();
      const root = openCouponsPage.closest('.cart__blocks-totals') || document;
      const strip = root.querySelector('.mini-coupon');
      const panel = root.querySelector('[data-coupon-page-panel]');
      if (strip) strip.style.display = 'none';
      if (panel) panel.style.display = 'block';
      return;
    }

    const closeCoupons = event.target.closest('[data-close-coupons]');
    if (closeCoupons) {
      event.preventDefault();
      setCouponPanel(false);
      return;
    }

    const scrollSummary = event.target.closest('[data-scroll-summary]');
    if (scrollSummary) {
      event.preventDefault();
      const summary = document.querySelector('.cart-drawer [data-cart-order-summary]');
      if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const removeBtn = event.target.closest('[data-remove-coupon]');
    if (removeBtn) {
      event.preventDefault();
      removeCoupon(removeBtn);
      return;
    }

    const removeGiftCardBtn = event.target.closest('[data-remove-gift-card]');
    if (removeGiftCardBtn) {
      event.preventDefault();
      removeGiftCard(removeGiftCardBtn);
      return;
    }

    const creditBtn = event.target.closest('[data-apply-store-credit]');
    if (creditBtn) {
      event.preventDefault();
      if (!creditBtn.disabled) applyStoreCredit(creditBtn);
      return;
    }

    const button = event.target.closest('[data-apply-coupon]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    const code = button.getAttribute('data-apply-coupon');
    const redirect = button.getAttribute('data-coupon-redirect') || window.location.pathname || '/cart';
    button.disabled = true;
    button.textContent = 'Applying…';
    applyCoupon(code, redirect, button);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-coupon-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('[name="discount"]');
    const code = input && input.value.trim();
    const submit = form.querySelector('[type="submit"]');
    if (!code) return;
    applyCoupon(code, window.location.pathname || '/cart', submit);
  });

  let isSyncingGiftCard = false;
  function syncGiftCardState() {
    if (isSyncingGiftCard) return;
    isSyncingGiftCard = true;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.attributes || cart.attributes._gift_card_applied !== 'true') {
          isSyncingGiftCard = false;
          return;
        }
        const token = (typeof window !== 'undefined' && window.storefrontAccessToken) || STOREFRONT_TOKEN;
        return resolveCartId().then(function (cartId) {
          if (!cartId) {
            isSyncingGiftCard = false;
            return;
          }
          return fetch(STOREFRONT_API_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': token,
            },
            body: JSON.stringify({
              query: `query getCart($id: ID!) {
                cart(id: $id) {
                  appliedGiftCards {
                    amountUsed { amount currencyCode }
                    balance { amount currencyCode }
                    lastCharacters
                  }
                }
              }`,
              variables: { id: cartId }
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              const sfCart = data && data.data && data.data.cart;
              if (!sfCart) return;
              const applied = sfCart.appliedGiftCards || [];
              if (applied.length === 0) {
                // Only clear if cartId was valid and confirmed to have no gift cards
                return;
              } else {
                const usedAmount = applied.reduce(function (sum, g) {
                  return sum + parseFloat((g.balance && g.balance.amount) || (g.amountUsed && g.amountUsed.amount) || 0);
                }, 0);
                const currSaved = parseFloat(cart.attributes._gift_card_amount || 0);
                if (usedAmount > 0 && Math.abs(usedAmount - currSaved) > 0.009) {
                  return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      attributes: {
                        _gift_card_amount: String(usedAmount)
                      }
                    })
                  }).then(updateCartUI);
                }
              }
            });
        });
      })
      .catch(function () {})
      .finally(function () {
        isSyncingGiftCard = false;
      });
  }

  window.refreshEarnLines = refreshEarnLines;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadLoyalty();
      refreshEarnLines();
      checkStoredCouponModal();
      syncGiftCardState();
    });
  } else {
    loadLoyalty();
    refreshEarnLines();
    checkStoredCouponModal();
    syncGiftCardState();
  }
  document.addEventListener('cart:updated', function () {
    loadLoyalty();
    refreshEarnLines();
    syncGiftCardState();
  });
  // Re-calculate points immediately when cart drawer opens or contents change
  document.addEventListener('cart-drawer:open', refreshEarnLines);
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      refreshEarnLines();
      setTimeout(refreshEarnLines, 100);
      setTimeout(refreshEarnLines, 400);
      setTimeout(refreshEarnLines, 1200);
    });
  }
  if (window.MutationObserver) {
    let earnRefreshTimer = null;
    const earnObserver = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const target = mutations[i].target;
        const node = target.nodeType === 1 ? target : target.parentElement;
        if (!node) continue;
        if (
          node.closest('.cart-order-summary') ||
          node.closest('[data-kc-earn]') ||
          node.matches('cart-drawer, cart-drawer-items, cart-items, .cart-wrapper, .drawer__footer, #main-cart-items, #main-cart-footer') ||
          node.querySelector('.cart-order-summary')
        ) {
          clearTimeout(earnRefreshTimer);
          earnRefreshTimer = setTimeout(refreshEarnLines, 50);
          return;
        }
      }
    });
    earnObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();